/** Lowercase, strip protocol/www/trailing slash */
export const normalizeWebsite = (url: string): string =>
  url
    .toLowerCase()
    .trim()
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "")
    .replace(/\/$/, "")

/** normalizeWebsite + take first part before dot, alphanumeric + hyphens only */
export const slugifyDomain = (domain: string) => {
  const cleaned = normalizeWebsite(domain)
  const domainPart = cleaned.split(".")[0] || cleaned
  return domainPart.replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")
}
